import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';

import { routing } from '../../app.routing';
import { ClubAttributesFormComponent } from '~features/club-overview/components/club-attributes-form/club-attributes-form.component';
import { ClubAttributesComponent } from '~features/club-overview/pages/club-attributes/club-attributes.component';
import { ClubUserListComponent } from '~features/club-overview/pages/club-user-list/club-user-list.component';
import { ClubUserCreateComponent } from '~features/club-overview/components/club-user-create/club-user-create.component';
import { ClubOverviewService } from './club-overview.service';
import { ClubComponent } from './pages/club-settings/club.component';
import { ClubFormsExtensionComponent } from './components/club-settings-forms/club-forms-extension.component';
import { EditClubAddressComponent } from '~features/club-overview/components/club-settings-forms/edit-club-address/edit-club-address.component';
import { EditClubBankDataComponent } from '~features/club-overview/components/club-settings-forms/edit-club-bank-data/edit-club-bank-data.component';
import { EditClubCommunicationComponent } from '~features/club-overview/components/club-settings-forms/edit-club-communication/edit-club-communication.component';
import { EditClubDataComponent } from '~features/club-overview/components/club-settings-forms/edit-club-data/edit-club-data.component';
import { CampaignComponent } from '~features/club-overview/components/club-settings-forms/edit-club-product-access/campaign/campaign.component';
import { TixxConnectComponent } from '~features/club-overview/components/club-settings-forms/edit-club-product-access/tixx-connect/tixx-connect.component';
import { TixxSelectComponent } from '~features/club-overview/components/club-settings-forms/edit-club-product-access/tixx-select/tixx-select.component';
import { EditWebsiteSettingsComponent } from '~features/club-overview/components/club-settings-forms/edit-website-settings/edit-website-settings.component';
import { ModulesFormComponent } from '~features/club-overview/components/club-settings-forms/modules-form/modules-form.component';
import { UploadClubLogoComponent } from '~features/club-overview/components/club-settings-forms/upload-club-logo/upload-club-logo.component';
import { WebhookCreateFormComponent } from '~features/club-overview/components/club-settings-forms/webhook-create-form/webhook-create-form.component';
import { WebhookFormComponent } from '~features/club-overview/components/club-settings-forms/webhook-form/webhook-form.component';
import { ClubAddressComponent } from '~features/club-overview/components/club-settings-info-tiles/club-address/club-address.component';
import { ClubCommunicationInfoComponent } from '~features/club-overview/components/club-settings-info-tiles/club-communication-info/club-communication-info.component';
import { ClubDataInfoComponent } from '~features/club-overview/components/club-settings-info-tiles/club-data-info/club-data-info.component';
import { ClubPersonalizationComponent } from '~features/club-overview/components/club-settings-info-tiles/club-personalization/club-personalization.component';
import { ClubProductAccessComponent } from '~features/club-overview/components/club-settings-info-tiles/club-product-access/club-product-access.component';
import { ModulesListComponent } from '~features/club-overview/components/club-settings-info-tiles/modules-list/modules-list.component';
import { WebhookSettingsComponent } from '~features/club-overview/components/club-settings-info-tiles/webhook-list/webhook-settings.component';
import { WebsiteSettingsComponent } from '~features/club-overview/components/club-settings-info-tiles/website-settings/website-settings.component';
import { FanScoreCardComponent } from '~features/club-overview/components/club-settings-forms/edit-club-product-access/fan-score-card/fan-score-card.component';
import { CampaiMembershipComponent } from '~features/club-overview/components/club-settings-forms/edit-club-product-access/campai-membership/campai-membership.component';
import { TixxWebshopComponent } from '~features/club-overview/components/club-settings-forms/edit-club-product-access/tixx-webshop/tixx-webshop.component';
import { ClubGdprSettingsInfoComponent } from '~features/club-overview/components/club-settings-info-tiles/club-gdpr-settings-info/club-gdpr-settings-info.component';
import { EditClubGdprSettingsComponent } from '~features/club-overview/components/club-settings-forms/edit-club-gdpr-settings/edit-club-gdpr-settings.component';
import { ButtonsModule } from '~shared/components/buttons/buttons.module';
import { TablesModule } from '~shared/components/tables/tables.module';
import { TooltipModule } from '~shared/components/tooltip/tooltip.module';
import { PipesModule } from '~shared/pipes/pipes.module';
import { DirectivesModule } from '~shared/directives/directives.module';
import { FormValidationModule } from '~core/components/form-validation/form-validation.module';
import { FormFieldsModule } from '~shared/components/form-fields/form-fields.module';

/**
 * Module for customer overview section
 */
@NgModule({
  declarations: [
    WebhookSettingsComponent,
    WebhookFormComponent,
    WebhookCreateFormComponent,
    ClubAddressComponent,
    ClubProductAccessComponent,
    ClubDataInfoComponent,
    ClubCommunicationInfoComponent,
    ClubAttributesFormComponent,
    UploadClubLogoComponent,
    ModulesListComponent,
    ModulesFormComponent,
    ClubComponent,
    ClubAttributesComponent,
    EditClubDataComponent,
    EditClubCommunicationComponent,
    EditClubAddressComponent,
    EditClubBankDataComponent,
    ClubPersonalizationComponent,
    ClubFormsExtensionComponent,
    WebsiteSettingsComponent,
    EditWebsiteSettingsComponent,
    TixxConnectComponent,
    TixxSelectComponent,
    CampaignComponent,
    ClubUserListComponent,
    ClubUserCreateComponent,
    FanScoreCardComponent,
    CampaiMembershipComponent,
    TixxWebshopComponent,
    ClubGdprSettingsInfoComponent,
    EditClubGdprSettingsComponent
  ],
  exports: [
    WebhookSettingsComponent,
    WebhookFormComponent,
    WebhookCreateFormComponent,
    ClubAddressComponent,
    ClubProductAccessComponent,
    ClubDataInfoComponent,
    ClubCommunicationInfoComponent,
    ClubAttributesFormComponent,
    UploadClubLogoComponent,
    ModulesListComponent,
    ModulesFormComponent,
    ClubComponent,
    ClubAttributesComponent,
    EditClubDataComponent,
    EditClubCommunicationComponent,
    EditClubAddressComponent,
    EditClubBankDataComponent,
    ClubPersonalizationComponent,
    ClubFormsExtensionComponent,
    WebsiteSettingsComponent,
    EditWebsiteSettingsComponent,
    TixxConnectComponent,
    TixxSelectComponent,
    CampaignComponent,
    ClubUserListComponent,
    ClubUserCreateComponent,
    CampaiMembershipComponent,
    TixxWebshopComponent,
    ClubGdprSettingsInfoComponent,
    EditClubGdprSettingsComponent
  ],
  providers: [
    DatePipe,
    ClubOverviewService
  ],
  imports: [
    CommonModule,
    routing,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    DirectivesModule,
    ColorPickerModule,
    FormValidationModule,
    FormFieldsModule,
    ButtonsModule,
    TooltipModule,
    TablesModule
  ]
})
export class ClubOverviewModule { }
